module.exports = __webpack_public_path__ + "img/banner_mobile.b9cf27aa.png";